import { useEffect, useRef } from 'react'
import TenantBar from './TenantBar.jsx'
import MenuButton from './MenuButton.jsx'
import UserBar from './UserBar.jsx'
import NotificationBar from './NotificationBar.jsx'
import { Link } from 'react-router-dom'

const HeaderNavBar = ({openMenu,setOpenMenu,companiesList,branchesList,tenantUsername,tenantImage,tenant,companySelected,branchSelected}) => {
    const headerRef = useRef(null)
    useEffect(() => {
        const headerElement = headerRef.current
        if (!headerElement) return
        const update = () => {
            document.documentElement.style.setProperty('--header-height', `${headerElement.offsetHeight}px`)
        }
        update()
        const observer = new ResizeObserver(update)
        observer.observe(headerElement)
        return () => observer.disconnect()
    }, [])
    return (
        <>
                <div ref={headerRef} className=' w-[100%] ms-auto flex justify-between items-center bg-[#251658]  sticky top-0 z-50 text-white  '>
            <div className="  m-auto  w-full  px-1  flex justify-between items-center ">
                <div className='relative flex w-full items-center justify-between py-1'>
                    <div className='flex min-w-0 items-center justify-start pe-20'>
                        {/* <MenuButton openMenu = {openMenu}  setOpenMenu = {setOpenMenu} /> */}
                        <div className="flex min-w-0 items-center gap-2">
                            <TenantBar 
                                companiesList = {companiesList}
                                branchesList = {branchesList}
                                companySelected={companySelected} 
                                branchSelected={branchSelected} />
                        </div>
                    </div>
                    
                    <Link to="/" className='absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 items-center justify-center' aria-label='Absat ERP'  >
                        <img className='w-6' src='/logo.png?v=absat-logo-2026-06-22' alt='Absat ERP'  />
                    </Link>
                    <div className='flex min-w-0 justify-end ps-20'>
                    <UserBar
                        tenantUsername = {tenantUsername}
                        tenantImage = {tenantImage}
                        tenant = {tenant}
                    />
                    </div>
                </div> 
            </div>
            </div>
        </>
    )
}

export default  HeaderNavBar 
